import { render } from "./ThreeDots.vue?vue&type=template&id=33ded6a7"
import script from "./ThreeDots.vue?vue&type=script&lang=js"
export * from "./ThreeDots.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__